import AddressEditor from "./AddressEditor";
export default {
  name: "UpdateAdd",
  components: {
    AddressEditor: AddressEditor
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    hasAddr: function hasAddr() {
      var _this$item;

      return !!((_this$item = this.item) !== null && _this$item !== void 0 && _this$item.addr);
    }
  }
};